import React from 'react';
import { Link } from 'react-router-dom';
import companyData from '../data/companyData';
import './Footer.css';

const serviceLinks = [
  { label: 'Custom Software Development', path: '/services#custom-software-development' },
  { label: 'Application Modernization',    path: '/services#application-modernization' },
  { label: 'Cloud & Microsoft Azure',      path: '/services#cloud-azure' },
  { label: 'Data, AI & Automation',        path: '/services#data-ai-automation' },
  { label: 'Quality Assurance',            path: '/services#quality-assurance' },
  { label: 'Staff Augmentation',           path: '/staff-augmentation' },
  { label: 'Dedicated Teams',              path: '/dedicated-teams' },
  { label: 'Managed Project Delivery',     path: '/managed-project-delivery' },
  { label: 'Government & Subcontracting',  path: '/government-subcontracting' },
];

const companyLinks = [
  { label: 'About Us',      path: '/about' },
  { label: 'Industries',    path: '/industries' },
  { label: 'Case Studies',  path: '/case-studies' },
  { label: 'Insights',      path: '/insights' },
  { label: 'Contact',       path: '/contact' },
];

const legalLinks = [
  { label: 'Privacy Policy',          path: '/privacy' },
  { label: 'Terms of Service',        path: '/terms' },
  { label: 'Accessibility Statement', path: '/accessibility' },
];

export default function Footer() {
  return (
    <footer className="footer">

      {/* CTA strip */}
      <div className="footer__cta-strip">
        <div className="container footer__cta-inner">
          <div className="footer__cta-text">
            <h4 className="footer__cta-heading">Ready to Strengthen Your Technology Delivery?</h4>
            <p className="footer__cta-sub">
              Tell us what you're trying to accomplish, where delivery is slowing down, or which skills your team needs.
            </p>
          </div>
          <Link to="/contact" className="btn btn-primary">Discuss Your Technology Needs</Link>
        </div>
      </div>

      <div className="footer__main">
        <div className="container footer__grid">

          {/* Brand column */}
          <div className="footer__brand">
            <Link to="/" className="footer__logo" aria-label="PROVIRTUES homepage">
              <img
                src={`${process.env.PUBLIC_URL}/images/logo.png`}
                alt="PROVIRTUES"
                className="footer__logo-img"
              />
            </Link>
            <p className="footer__tagline">{companyData.valueProposition}</p>
            <div className="footer__socials">
              <a href={companyData.social.linkedin} target="_blank" rel="noreferrer" className="footer__social" aria-label="PROVIRTUES on LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" aria-hidden="true">
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="footer__col">
            <h4 className="footer__col-title">Services</h4>
            <ul className="footer__list">
              {serviceLinks.map(s => (
                <li key={s.label}><Link to={s.path}>{s.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="footer__col">
            <h4 className="footer__col-title">Company</h4>
            <ul className="footer__list">
              {companyLinks.map(c => (
                <li key={c.path}><Link to={c.path}>{c.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer__col">
            <h4 className="footer__col-title">Contact Us</h4>
            <ul className="footer__contact-list">
              <li>
                <span className="fci" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                </span>
                <span>Headquartered in<br/>{companyData.city}, {companyData.state}<br/>Serving clients nationwide</span>
              </li>
              <li>
                <span className="fci" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                </span>
                <a href={`mailto:${companyData.email}`}>{companyData.email}</a>
              </li>
              <li>
                <span className="fci" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </span>
                <span>{companyData.hours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>&copy; {new Date().getFullYear()} {companyData.name}. All rights reserved.</p>
          <div className="footer__legal">
            {legalLinks.map(l => <Link key={l.path} to={l.path}>{l.label}</Link>)}
          </div>
        </div>
        <div className="container">
          <p className="footer__legal-notice">{companyData.dbaNotice}</p>
        </div>
      </div>
    </footer>
  );
}
